import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResultAttribute } from '../result-map/model/result-attribute';
import { ResultMapFilterService } from '../result-map/service/result-map-filter.service';

@Component({
  selector: 'app-result-popup',
  templateUrl: './result-popup.component.html',
  styleUrls: ['./result-popup.component.scss']
})
export class ResultPopupComponent implements OnInit, OnDestroy {

  attributes: ResultAttribute[];
  public tags: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public properties: any,
    private resultMapFilterService: ResultMapFilterService
  ) { }

  ngOnInit(): void {
    if (this.properties.attributes) {
      this.attributes = JSON.parse(this.properties.attributes);
    }

    this.resultMapFilterService.tags$.subscribe(tags => this.tags = tags);
  }

  ngOnDestroy(): void {
    this.removeFilters();
  }

  filter(tag: string): void {
    if (this.tags.includes(tag)) {
      this.resultMapFilterService.removeFilter(tag);
    } else {
      this.resultMapFilterService.addFilter(tag);
    }
  }

  private removeFilters() {
    if (!this.attributes) {
      return;
    }
    const values: string[] = [];
    this.attributes.forEach(a => {
      if (a.tag) {
        values.push(a.tag);
      }
    });
    this.resultMapFilterService.removeFilter(...values);
  }
}
